import { gql } from "@apollo/client";

const SAVE_CREDENTIAL_MUTATION = gql`
  mutation save_credential(
    $name: String
    $new_name: String
    $credential_type: String
    $status: String
    $properties: GenericScalar
    $replace_properties: Boolean
  ) {
    save_credential(
      name: $name
      replace_properties: $replace_properties
      credential: { name: $new_name, credential_type: $credential_type, status: $status, properties: $properties }
    ) {
      ... on SaveCredentialOk {
        ok
        credential {
          name
        }
      }
      ... on InvalidCredential {
        message
      }
      ... on ValidationErrors {
        errors {
          typeId
          properties
        }
      }
    }
  }
`;

export { SAVE_CREDENTIAL_MUTATION };
